/**
 * Boat fuel-unit conversion (spec 05/07). Storage keeps whatever the user typed
 * (value + unit); the planner needs l/nm. Conversion goes through cruise speed:
 *   l/nm = (l/h) / cruiseKn
 */

export type FuelUnit = 'l_per_nm' | 'l_per_h';

export function toFuelLPerNm(value: number, unit: FuelUnit, cruiseKn: number): number {
  if (unit === 'l_per_nm') return value;
  return cruiseKn > 0 ? value / cruiseKn : 0;
}

export function toFuelLPerH(value: number, unit: FuelUnit, cruiseKn: number): number {
  if (unit === 'l_per_h') return value;
  return value * cruiseKn;
}

/** Convert a value between fuel units, preserving its meaning (spec 07). */
export function convertFuel(
  value: number,
  from: FuelUnit,
  to: FuelUnit,
  cruiseKn: number,
): number {
  if (from === to) return value;
  return to === 'l_per_nm'
    ? toFuelLPerNm(value, from, cruiseKn)
    : toFuelLPerH(value, from, cruiseKn);
}

/** Range (nm) from tank capacity and consumption. */
export function rangeNm(tankL: number, fuelLPerNm: number): number {
  return fuelLPerNm > 0 ? tankL / fuelLPerNm : 0;
}
